/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
    format, compareAsc, addMonths, addDays, startOfWeek, getWeek, startOfMonth, endOfMonth, getYear, isLastDayOfMonth, isSameMonth,
} from 'date-fns';
import ReactHTMLParser from 'react-html-parser';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
    object, bool, func, string, shape, arrayOf, number,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import mbpLogger from 'mbp-logger';
import getDeliveryCalendarByProduct from '../../../../../../apis/product-apis/getDeliveryCalendarByProduct';
import getCADRate from '../../../../../../apis/product-apis/getCADRate';
import memberDucks from '../../../../../../state/ducks/Member/ducks';
import { ducks as checkoutDucks } from '../../../../../../state/ducks/Checkout';
import { actions as tagManagerActions } from '../../../../../../state/ducks/TagManager';

import {
    getLocationType,
    getValidatedZipcode,
    getUserSubmittedProductFilterZipcode,
    getDataDictionary,
} from '../../../../../../state/ducks/App/App-Selectors';
import {
    getBrand,
} from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

import { getCurrencySymbol } from '../../../../../../state/ducks/App/ducks/Common/locale';
import { getCurrencyName } from '../../../../../../state/ducks/Member/ducks/Auth/helper/helper';

import FlexModal from './Partials/FlexModal';
import GraphqlPortalLoader from '../../../GraphqlCommonComponents/GraphqlPortalLoader';
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { checkDateHasBackUpProduct } from '../../../../../helpers/checkFptGptProductBackUp';
import determineIfPastCutoffTime from '../../../../../helpers/determineCutoffTime';

import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';
import findProductPageByPartNumber from '../../../../../gql/queries/findProductPageByPartNumber';

const {
    checkout: { checkoutActions },
    common: { commonSelectors: { getCartError, getLoaderStatus, isCheckoutPage }, commonDucks: { error: { errorActions } } },
    cart: {
        cartDucks: {
            updateCart: {
                updateCartActions: {
                    updateOrder,
                },
            },
        },
    },
} = checkoutDucks;

const {
    common: {
        commonSelectors: { getAccessToken },
    },
} = memberDucks;

const styles = (theme) => ({
    closeModal: {
        position: 'absolute',
        fontWeight: 'normal',
        right: '12px',
        color: theme.palette.colorNeutral70,
        cursor: 'pointer',
    },
    modelHeader: {
        borderBottom: `2px solid ${theme.palette.calendarPrimary || theme.palette.colorPrimary}`,
        textTransform: 'uppercase',
        color: theme.palette.calendarPrimary || theme.palette.colorPrimary,
        fontSize: '16px',
        fontWeight: 'bold',
        textAlign: 'center',
        padding: '15px 0px !important',
    },
    modelContainer: {
        [theme.breakpoints.up('sm')]: {
            top: '17% !important',
        },
        '& div': {
            alignItems: 'start',
            '& div': {
                maxHeight: '100%',
                height: '100%',
                width: '100%',
                margin: '0px',
                alignItems: 'start',
                padding: '0px',
                borderRadius: '0px',
                maxWidth: '670px !important',
                position: 'relative',
                [theme.breakpoints.up('sm')]: {
                    display: 'block',
                    height: 'auto',
                },
            },
        },
    },
    monthTitle: {
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: '700',
        textTransform: 'uppercase',
        margin: '10px 0px !important',
    },
    daysRow: {
        display: 'flex !important',
    },
    weekDay: {
        display: 'inline-block',
        textAlign: 'center',
        marginLeft: '4%',
        marginRight: '4%',
        fontSize: '14px',
        fontWeight: '400',
        [theme.breakpoints.down(1025)]: {
            marginLeft: '0',
            marginRight: '0',
            width: '13.5%',
        },
    },
    dateIcon: {
        position: 'absolute',
        right: 0,
        top: 0,
    },
    weekDayName: {
        display: 'flex !important',
        flexWrap: 'wrap',
    },
    dateAvailable: {
        background: theme.palette.colorPrimaryContrast,
        cursor: 'pointer',
        border: `1px solid  ${theme.palette.grey10}`,
        width: '11.6% !important',
        display: 'inline-block',
        textAlign: 'center',
        margin: '1%',
        color: theme.palette.colorPrimary,
        fontSize: '12px',
        fontWeight: '500',
        padding: '8px 0px',
        position: 'relative',
        '&:hover': {
            fontWeight: '600',
        },
        [theme.breakpoints.down(1025)]: {
            minHeight: 40,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            fontWeight: 'bold',
            padding: '6px 0',
            lineHeight: '14px',
        },
    },
    dateSurcharge: {
        color: '#20b4de',
        padding: '4px 0',
        '&:hover': {
            // color: theme.palette.colorPrimaryContrast,
            // background: '#20b4de',
            padding: '8px 0',
            fontWeight: '600',
            '& p': {
                display: 'none',
            },
        },
    },
    surcharge: {
        color: theme.palette.grey3,
        fontSize: 8,
        margin: '4px auto 0 auto',
        lineHeight: '8px',
        [theme.breakpoints.up('md')]: {
            margin: '0',
        },
    },
    noDateAvailable: {
        background: theme.palette.grey9,
        border: `1px solid ${theme.palette.grey10}`,
        width: '11.6% !important',
        display: 'inline-block',
        textAlign: 'center',
        color: '#9e9e9e',
        margin: '1%',
        fontSize: '12px',
        fontWeight: '500',
        padding: '8px 0px',
        '& notVisible': {
            visibility: 'hidden',
        },
        [theme.breakpoints.down(1025)]: {
            minHeight: 40,
            lineHeight: '14px',
        },
    },
    deliveryIcon: {
        display: 'inline-block',
        borderRadius: '100%',
        width: '16px',
        height: '16px',
        background: theme.palette.grey10,
        marginRight: '5px',
        verticalAlign: 'text-bottom',
    },
    mainDiv: {
        fontSize: '14px',
        fontWeight: '400',
        padding: '3px 0px 0px 15px !important',
        width: 'initial !important',
    },
    prevBtn: {
        position: 'absolute',
        left: '15px',
        color: theme.palette.calendarPrimary || theme.palette.colorPrimary,
        fontSize: '14px',
        fontWeight: '700',
        cursor: 'pointer',
        '&::before': {
            content: '"<"',
            paddingRight: '7px',
        },
    },
    nextBtn: {
        position: 'absolute',
        right: '15px',
        color: theme.palette.calendarPrimary || theme.palette.colorPrimary,
        fontSize: '14px',
        fontWeight: '700',
        cursor: 'pointer',
        '&::after': {
            content: '">"',
            paddingLeft: '8px',
        },
    },
    spinnerContainer: {
        width: '100%',
        // textAlign: 'center',
    },
    spinner: {
        color: theme.palette.colorPrimary,
        top: '50%',
        left: '50%',
        zIndex: '10000',
    },
    mobBottomDiv: {
        margin: '0px 0px 15px !important',
        [theme.breakpoints.up('sm')]: {
            display: 'none !important',
        },
    },
    mobBottomRight: {
        width: '47% !important',
        display: 'inline-block',
        '& img': {
            width: 'auto !important',
            padding: '15px 0px',
        },
    },
    mobBottomLeft: {
        width: '53% !important',
        display: 'inline-block',
        verticalAlign: 'top',
    },
    leftCalendar: {
        [theme.breakpoints.up('sm')]: {
            width: '66% !important',
            float: 'left',
            margin: '20px 0px 20px 5px !important',
        },
        '&::before': {
            width: '100%',
            height: '100%',
            content: '""',
        },
    },
    rightCalendar: {
        [theme.breakpoints.up('sm')]: {
            width: '28% !important',
            float: 'left',
            margin: '8px !important',
            textAlign: 'center',
            borderRadius: '5px !important',
            border: `2px solid ${theme.palette.grey10}`,
            justifyContent: 'flex-start',
            padding: '4px !important',
            marginTop: '30px !important',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    rightTop: {
        [theme.breakpoints.up('sm')]: {
            borderBottom: `1px solid ${theme.palette.grey10}`,
            padding: '20px 0px !important',
        },
        '& p': {
            [theme.breakpoints.up('sm')]: {
                margin: '0px',
                fontSize: '14px',
            },
        },
        '& span': {
            [theme.breakpoints.up('sm')]: {
                fontSize: '18px',
                fontWeight: '700',
                textTransform: 'uppercase',
            },
        },
    },
    closeModalEmpty: {
        minHeight: 40,
        border: 0,
    },
    cartError: {
        fontSize: 15,
        marginTop: 0,
        textAlign: 'center',
        padding: '5px',
    },
    errorIcon: {
        color: theme.palette.error.main,
        verticalAlign: 'bottom',
    },
    rightLogoImage: {
        width: '100%',
    },
    mobMarkDiv: {
        [theme.breakpoints.up('sm')]: {
            textAlign: 'left !important',
            padding: '1px 0px !important',
        },
    },
    plaMobMark: {
        [theme.breakpoints.up('sm')]: {
            fontSize: '14px',
            fontWeight: '400',
            padding: '10px 0px 10px 15px !important',
            width: 'initial !important',
        },
    },
    mobMark: {
        [theme.breakpoints.up('sm')]: {
            fontSize: '14px',
            fontWeight: '400',
            padding: '10px 0px 10px 15px !important',
            width: 'initial !important',
            borderBottom: `1px solid ${theme.palette.grey10}`,
        },
    },
    deliveryImg: {
        [theme.breakpoints.up('sm')]: {
            padding: '20px 0px !important',
            borderBottom: `1px solid ${theme.palette.grey10}`,
        },
        '& img': {
            [theme.breakpoints.up('sm')]: {
                width: 'auto !important',
            },
        },
    },
    standardCharge: {
        [theme.breakpoints.up('sm')]: {
            padding: '20px 0px !important',
            borderBottom: `1px solid ${theme.palette.grey10}`,
            fontSize: '14px',
        },
    },
    rightLogo: {
        [theme.breakpoints.up('sm')]: {
            padding: '20px 0px 10px  !important',
        },
    },
    loadingFadeOut: {
        '&::before': {
            width: '100%',
            height: '100%',
            content: '""',
            zIndex: '100',
            backgroundColor: 'rgba(255,255,255,0.5)',
            position: 'absolute',
        },
    },
    maxClosedWidth: {
        '& div': {
            '& div': {
                maxWidth: '300px !important',
                borderRadius: 2,
                paddingBottom: 10,
            },
        },
    },
    todayTomDateNotAvailContainer: {
        width: '100%',
        background: '#f4f2f7',
        '& p': {
            padding: '10px',
            margin: 0,
            textAlign: 'center',
            color: '#f71449',
            fontSize: '15px',
        },
    },
    selecteDate: {
        color: 'white !important',
        background: theme.palette.colorPrimary,
    },

});

const WWW_WEEKDAY_SHORTNAMES = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
];
const MMMM_MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
const weekStartsOn = 0; // WEEK STARTS ON SUNDAY || 0 - SUNDAY | 1 - MONDAY | 2 - TUESDAY
const z2fmt = (v) => (v < 10 ? '0' : '') + v; // e.g. '03', '12'
const formatDateYYYY_MM_DD = (d) => `${d.getFullYear()}-${z2fmt(d.getMonth() + 1)}-${z2fmt(d.getDate())}`; // e.g. '2019-11-01'
const yyyy_mm_ddToDate = (dateString) => {
    // YYYY-MM-DD date string to JS Date.  Made to avoid doing Date('YYYY-MM-DD') because that assumes UTC.
    const m = dateString.match(/^\s*(\d\d\d\d)-(\d\d?)-(\d\d?)\s*$/);
    if (m) {
        return new Date(m[1], m[2] - 1, m[3]);
    }
    return 0;
};
const getNow = () => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
}; // 12:00 midnight of current day
const firstOfNextMonth = (d) => addMonths(startOfMonth(new Date(d)), 1);
const firstofPrevMonth = (d) => {
    const m = d.getMonth();
    return m === 0
        ? new Date(d.getFullYear() - 1, 11, 1)
        : new Date(d.getFullYear(), m - 1, 1);
};

export class CalendarModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prevBtnCheck: false,
            surcharge: 'Standard Service Charge',
            now: '',
            end: '',
            spinnerActive: false,
            calendarIsLoading: false,
            focusedDate: null,
            flex: {
                flexActivated: false,
                flexData: {},
                selectedDate: null,
            },
            dateIcons: {},
            retailPriceObj: {},
        };
        // The following object is instantiated outside of state so that assigment is syncronous.
        this.apiDateObj = {};
    }

    componentDidMount() {
        const { location, selectedSku } = this.props;
        if (location.pathname.includes('checkout') || location.pathname.includes('add-ons')) {
            this.getCalendarFromAPI();
        }

        // retailPriceObj for multicurrency
        const currentCurrency = getCurrencyName();
        const retailPriceObj = {
            [currentCurrency]: selectedSku?.prices?.[0]?.value,
        };
        this.setState({
            retailPriceObj,
        });
    }

    componentDidUpdate(prevProps) {
        const { calendarIsLoading } = this.state;
        const { isOpen, cmsData, selectedSku } = this.props;

        // The commented code below does prefetching of calendar dates when
        // there is already a zip stored in redux.
        // It was disabled because it was causing some bugs when copy pasting zips
        // uncomment to reenable
        // if user changes zipcodes and the new one is valid prefetch dates
        // if (validatedZip !== '' && validatedZip !== prevProps.validatedZip) {
        //     this.setState({
        //         prevBtnCheck: false,
        //         now: '',
        //         end: '',
        //     });
        //     this.apiDateObj = {};
        //     this.getCalendarFromAPI();
        // }
        // // if user changes SKUs and there is a valid zip, prefetch calendar dates
        // if (
        //     selectedItemId !== prevProps.selectedItemId
        //     && validatedZip !== ''
        // ) {
        //     this.setState({
        //         prevBtnCheck: false,
        //         now: '',
        //         end: '',
        //     });
        //     this.apiDateObj = {};
        //     this.getCalendarFromAPI();
        // }
        // if user previously opened the calendar, went ahead to a future month then closed the calendar
        // and reopens it we want to display the current month so if calendar is opened and dates are not currently being
        // prefetched we get calendar dates
        if (
            ((isOpen === true
            && isOpen !== prevProps.isOpen) || (isOpen && cmsData && !prevProps.cmsData))
            && calendarIsLoading === false
        ) {
            this.getCalendarFromAPI();
        }
        if (!prevProps.cmsData && cmsData) {
            const dateIcons = {};
            const calenderDateIcon = cmsData?.entries?.[0]?.calendar_date_icons;
            const dateIconArray = calenderDateIcon?.[0]?.date && calenderDateIcon;
            if (!(selectedSku?.sympathyValue === '2' || selectedSku?.sympathyValue === '1') && dateIconArray && dateIconArray.length > 0) {
                dateIconArray.forEach((dateInfo) => {
                    dateIcons[dateInfo.date] = dateInfo;
                });
            }
            if (Object.keys(dateIcons).length > 0) {
                this.setState({
                    dateIcons,
                });
            }
        }
    }

    getCalendarFromAPI = async (startDate = formatDateYYYY_MM_DD(getNow())) => {
        const { currencyRate } = this.state;
        const {
            locationType,
            userSubmittedZip,
            jwt,
            selectedItemId,
            brandId,
            setCalendarDataLoadingFlag,
            handleDeliveryAvailability,
            clearCartError,
            zipCode,
            isInternationalProduct,
            flags,
            passportInCart,
            isPassportUser,
            isUserLoggedIn,
            deliveryType,
            brand,
        } = this.props;

        const currentCurrency = getCurrencyName();
        if (!currencyRate && currentCurrency === 'CAD' && flags['is-canada-homegrown-checkout-on']) {
            await getCADRate(jwt)
                .then((data) => {
                    this.setState({
                        currencyRate: data.data?.currencyRate || '',
                    });
                })
                .catch((err) => {
                    setCalendarDataLoadingFlag(false);
                    handleDeliveryAvailability(false);
                    mbpLogger.logError({
                        component: 'GraphqlPDPCalendar',
                        apiCall: 'getCADRate',
                        jsError: err,
                        jwt,
                    });
                });
        }

        const today = new Date();
        let zipToSearch = userSubmittedZip;
        if (zipCode) {
            zipToSearch = zipCode;
        }
        // set zipcode as 00000 if the product is international
        zipToSearch = isInternationalProduct ? '00000' : zipToSearch || 35005;
        clearCartError({
            errType: 'cart',
            field: 'error',
        });
        // const startDate = '2020-05-01';

        // Starting at the end of the string (backwards pattern matching), continue to match any characters that aren't '-' or '_'
        const itemSku = selectedItemId.match(/[^-_]*$/);
        this.setState({ calendarIsLoading: true });

        let customerType = isUserLoggedIn ? 'R' : 'G';
        if (passportInCart || (isUserLoggedIn && isPassportUser)) {
            customerType = 'P';
        }

        getDeliveryCalendarByProduct(
            {},
            jwt,
            itemSku,
            brandId,
            zipToSearch,
            locationType,
            // if it's the last day of the month and it's after the cutoff time the calendar API
            // only gives back one month of dates. However, the calendar only displays the 'next' button to browse
            // additional months if there are dates in a second month that come back from the API
            // Below checks if it's both the last day of the month and is past the cutoff time
            // if so, query the calendar for the first day of the next month which will correctly
            // return two months of data from the delivery calednar API
            (isLastDayOfMonth(today) && ((deliveryType === 'FPT' && determineIfPastCutoffTime()) || (deliveryType === 'GPT'))) ? format(addDays(today, 1), 'yyyy-MM-dd') : startDate,
            customerType,
            brand?.code,
        )
            .then(({ data }) => {
                setCalendarDataLoadingFlag(false);
                this.setState({ calendarIsLoading: false });
                if (data.response.calendarDates.length === 0) {
                    handleDeliveryAvailability(false);
                    return;
                }
                this.generateState(data.response.calendarDates);
            })
            .catch((err) => {
                setCalendarDataLoadingFlag(false);
                this.setState({ calendarIsLoading: false });
                handleDeliveryAvailability(false);
                mbpLogger.logError({
                    component: 'GraphqlPDPCalendar',
                    apiCall: 'getDeliveryCalendarByProduct',
                    jsError: err,
                    jwt,
                    itemSku,
                    brandId,
                    zipToSearch,
                    locationType,
                    startDate,
                });
            });
    };

    generateState = (apiResponse) => {
        this.generateCalendarObject(apiResponse);

        this.setState(
            {
                now: yyyy_mm_ddToDate(apiResponse[0].deliveryDate),
                end: yyyy_mm_ddToDate(
                    apiResponse[apiResponse.length - 1].deliveryDate,
                ),
                spinnerActive: false,
            },
            this.checkPrevButton,
        );
    };

    generateCalendarObject = (apiResponse) => {
        apiResponse.forEach(async (date) => {
            this.apiDateObj[date.deliveryDate] = date;
        });
        // below is mother's day specific logic. Will be removed after the holiday.
        // If one of a specific set of hardcoded SKUs has no delivery availability on the 6th-10th inclusive for a zip
        // then check if there are any available products in a specific category for that zipcode
    };

    generateCalendar = (now, end) => {
        let calendarDay = startOfWeek(new Date(now), { weekStartsOn });
        const endDay = endOfMonth(end);
        const calendarDays = {};
        while (compareAsc(new Date(calendarDay), new Date(endDay)) === -1) {
            const weekNumber = getWeek(new Date(calendarDay), { weekStartsOn });
            if (!calendarDays[weekNumber]) {
                calendarDays[weekNumber] = [];
            }
            if (!this.apiDateObj[formatDateYYYY_MM_DD(calendarDay)]) {
                calendarDays[weekNumber].push({
                    date: new Date(calendarDay),
                    available: false,
                });
            } else {
                calendarDays[weekNumber].push({
                    date: new Date(calendarDay),
                    available: true,
                    data: this.apiDateObj[formatDateYYYY_MM_DD(calendarDay)],
                });
            }
            calendarDay = addDays(new Date(calendarDay), 1);
        }
        return calendarDays;
    };

    generateMonth = (calendar, startWeek, endWeek) => {
        const month = [];
        let weekTracker = startWeek;
        while (weekTracker !== endWeek + 1) {
            if (calendar[weekTracker]?.length) {
                month.push(calendar[weekTracker]);
            }
            weekTracker += 1;
            if (weekTracker === 53 && endWeek !== 53) {
                weekTracker = 1;
            }
        }
        return month;
    };

    checkPrevButton = () => {
        const { now } = this.state;
        if (now.getMonth() === getNow().getMonth() && now.getYear() === getNow().getYear()) {
            this.setState({ prevBtnCheck: false });
        } else {
            this.setState({ prevBtnCheck: true });
        }
    };

    preMonth = () => {
        const { now } = this.state;
        this.setState({
            spinnerActive: true,
        });
        this.getCalendarFromAPI(formatDateYYYY_MM_DD(firstofPrevMonth(now)));
    };

    nextMonth = () => {
        const { now } = this.state;
        this.setState({
            spinnerActive: true,
        });
        this.getCalendarFromAPI(formatDateYYYY_MM_DD(firstOfNextMonth(now)));
    };

    flexAddToCart = (flexDate) => {
        const { flex: { selectedDate } } = this.state;
        const {
            actionAddToCart,
            actionUpdateOrder,
            selectedItemId,
            brandId,
            history,
            userSubmittedZip,
            locationType,
            location,
            orderItemId,
            close,
            deliveryType,
            ageDetails,
            partNumber,
            sympathyValue,
            pageType,
            isInternationalProduct,
            internationalCountry,
            isPassportBundleItem,
            personalization,
            movieSelected,
            isPassportBundleProduct,
            selectedSku,
            hasWine,
        } = this.props;
        const { retailPriceObj } = this.state;
        if (!location.pathname.includes('checkout') && !location.pathname.includes('add-ons')) {
            let categoryId = null;
            let categoryName = null;
            let categoryPath = null;
            // if the user direct loads a product page there will be no categoryId
            if (location) {
                categoryPath = location.pathname;

                if (location.state) {
                    const { fromCategoryPage } = location.state;

                    if (fromCategoryPage) {
                        if (location.state.categoryId) {
                            categoryId = location.state.categoryId;
                        }

                        if (location.state.categoryPath) {
                            categoryPath = location.state.categoryPath;
                        }

                        if (location.state.categoryName) {
                            categoryName = location.state.categoryName;
                        }
                    }
                }
            } else {
                categoryId = null;
            }

            let skipAddons = false;
            let passportBundle = {};
            // sympathyValue: '1' - Home, '2' - Funeral
            if ((location.state && location.state.skipAddons) || (sympathyValue === '1' || sympathyValue === '2')) {
                skipAddons = true;
            }
            // if passportBundle flow; redirect to /checkout
            if (isPassportBundleProduct?.enable) {
                skipAddons = true;
                passportBundle = {
                    enable: true,
                    passportSku: isPassportBundleProduct?.passportSku,
                };
            }

            const attributes = [];
            // Attr: categoryId
            if (categoryId) {
                attributes.push({
                    attributeName: 'categoryId',
                    attributeValue: categoryId,
                });
            }

            // Attr: categoryIdent
            if (categoryName) {
                attributes.push({
                    attributeName: 'categoryIdent',
                    attributeValue: categoryName,
                });
            }

            // Attr: categoryPath
            if (categoryPath) {
                attributes.push({
                    attributeName: 'categoryPath',
                    attributeValue: categoryPath,
                });
            }

            // set zipcode as 00000 if the product is international
            const deliveryZipCode = isInternationalProduct ? '00000' : userSubmittedZip;

            /* Feature - FPT / GPT - Back Up Product - Start */

            let productCode = selectedItemId;
            let productPartNumber = partNumber;

            const backUpProductBrandCode = selectedDate?.data?.backupSkuBrand;
            const backUpProductSkuCode = selectedDate?.data?.backupSkuCode;

            const backUpProduct = checkDateHasBackUpProduct(productCode, backUpProductBrandCode, backUpProductSkuCode);

            if (backUpProduct.hasProduct) {
                productCode = backUpProduct.productCode;
                productPartNumber = backUpProduct.productCode;
            }

            /* Feature - FPT / GPT - Back Up Product - End */
            let personalizationLines;
            if (personalization?.lineState) {
                personalizationLines = personalization.lineState?.map((line, i) => ({
                    perAttributeId: `${i + 1}`,
                    perAttributeValue: personalization.lineState[i].lineText,
                }));
            }

            const reqObj = {
                brandCode: brandId,
                productCode,
                quantity: 1,
                delivery: {
                    calendarDateType: selectedDate.data.calendarDateType,
                    deliveryDate: format(selectedDate.date, 'yyyy-MM-dd'),
                    zipCode: deliveryZipCode,
                    locationType,
                    deliverySLA: selectedDate.data.deliverySLA,
                    flex: {
                        flexOptionId: flexDate.optionCode,
                        forcedDate: `${flexDate.forcedDelDate},${flexDate.flexDate}`,
                        flexMessages: flexDate.flexMsg.map((message) => ({
                            flxMsg: message.msgText,
                            flxMsgLoc: message.msgTypeLocation,
                        })),
                    },
                },
                attributes,
            };

            if (personalizationLines) {
                reqObj.personalization = {
                    personalizationType: 'PRODUCT_PERSONALIZATION',
                    personalizationLines,
                };
            }

            if (
                ageDetails && ageDetails.birthDay && ageDetails.birthMonth
                && ageDetails.birthYear && ageDetails.minAge && hasWine === 'true'
            ) {
                reqObj.wineVerify = {
                    ...ageDetails,
                };
            }

            if (isInternationalProduct) {
                reqObj.delivery.countryCode = internationalCountry;
            }
            actionAddToCart(
                reqObj,
                history,
                deliveryType, // FPT or GPT
                categoryId,
                productPartNumber,
                skipAddons,
                selectedDate.date,
                categoryName,
                categoryPath,
                isPassportBundleItem,
                movieSelected,
                selectedSku,
                passportBundle,
                retailPriceObj,
            );
        } else {
            const payload = {
                updateDeliveryDate: {
                    calendarDateType: selectedDate.data.calendarDateType,
                    deliveryDate: format(selectedDate.date, 'yyyy-MM-dd'),
                    deliverySLA: selectedDate.data.deliverySLA,
                    flex: {
                        flexOptionId: flexDate.optionCode,
                        forcedDate: `${flexDate.forcedDelDate},${flexDate.flexDate}`,
                        flexMessages: flexDate.flexMsg.map((message) => ({
                            flxMsg: message.msgText,
                            flxMsgLoc: message.msgTypeLocation,
                        })),
                    },
                },
                orderItemId,
            };

            const updateOrderProps = {
                page: location.pathname.includes('checkout') || location.pathname.includes('add-ons') ? pageType : null,
                updateType: 'delivery',
            };
            actionUpdateOrder(payload, updateOrderProps, close);
        }
    }

    selectDate = (selectedDate) => {
        const {
            actionAddToCart,
            actionUpdateOrder,
            selectedItemId,
            brandId,
            history,
            userSubmittedZip,
            locationType,
            location,
            orderItemId,
            close,
            deliveryType,
            ageDetails,
            partNumber,
            sympathyValue,
            pageType,
            trackEvent,
            isInternationalProduct,
            internationalCountry,
            isPassportBundleItem,
            personalization,
            movieSelected,
            isPassportBundleProduct,
            selectedSku,
            hasWine,
            brand,
            setDeliveryDate,
        } = this.props;
        const { retailPriceObj } = this.state;
        if (selectedDate.data.flex) {
            this.setState({
                flex: {
                    flexActivated: true,
                    flexData: selectedDate.data.flex,
                    selectedDate,
                },
            });
            return;
        }
        setDeliveryDate(selectedDate);
        if (brand.code === 'PLA' && !location.pathname.includes('checkout')) {
            close();
            trackEvent({
                eventName: 'feature_interaction',
                eventCategory: 'Product Page',
                eventAction: 'Delivery Date Updated',
                eventLabel: format(selectedDate.date, 'yyyy-MM-dd'),
            });
            return;
        }
        if (!location.pathname.includes('checkout') && !location.pathname.includes('add-ons')) {
            let categoryId = null;
            let categoryName = null;
            let categoryPath = null;
            // if the user direct loads a product page there will be no categoryId

            if (location) {
                categoryPath = location.pathname;

                if (location.state) {
                    const { fromCategoryPage } = location.state;

                    if (fromCategoryPage) {
                        if (location.state.categoryId) {
                            categoryId = location.state.categoryId;
                        }

                        if (location.state.categoryPath) {
                            categoryPath = location.state.categoryPath;
                        }

                        if (location.state.categoryName) {
                            categoryName = location.state.categoryName;
                        }
                    }
                }
            } else {
                categoryId = null;
            }

            let skipAddons = false;
            let passportBundle = {};
            // sympathyValue: '1' - Home, '2' - Funeral
            if ((location.state && location.state.skipAddons) || (sympathyValue === '1' || sympathyValue === '2')) {
                skipAddons = true;
            }

            // if passportBundle flow; redirect to /checkout
            if (isPassportBundleProduct?.enable) {
                skipAddons = true;
                passportBundle = {
                    enable: true,
                    passportSku: isPassportBundleProduct?.passportSku,
                };
            }

            // Attributes
            const attributes = [];

            // Attr: categoryId
            if (categoryId) {
                attributes.push({
                    attributeName: 'categoryId',
                    attributeValue: categoryId,
                });
            }

            // Attr: categoryIdent
            if (categoryName) {
                attributes.push({
                    attributeName: 'categoryIdent',
                    attributeValue: categoryName,
                });
            }

            // Attr: categoryPath
            if (categoryPath) {
                attributes.push({
                    attributeName: 'categoryPath',
                    attributeValue: categoryPath,
                });
            }

            // set zipcode as 00000 if the product is international
            const deliveryZipCode = isInternationalProduct ? '00000' : userSubmittedZip;

            /* Feature - FPT / GPT - Back Up Product - Start */

            let productCode = selectedItemId;
            let productPartNumber = partNumber;

            const backUpProductBrandCode = selectedDate?.data?.backupSkuBrand;
            const backUpProductSkuCode = selectedDate?.data?.backupSkuCode;

            const backUpProduct = checkDateHasBackUpProduct(productCode, backUpProductBrandCode, backUpProductSkuCode);

            if (backUpProduct.hasProduct) {
                productCode = backUpProduct.productCode;
                productPartNumber = backUpProduct.productCode;
            }

            /* Feature - FPT / GPT - Back Up Product - End */
            let personalizationLines;
            if (personalization?.lineState) {
                personalizationLines = personalization.lineState?.map((line, i) => ({
                    perAttributeId: `${i + 1}`,
                    perAttributeValue: personalization.lineState[i].lineText,
                }));
            }
            const reqObj = {
                brandCode: brandId,
                productCode,
                quantity: 1,
                delivery: {
                    calendarDateType: selectedDate.data.calendarDateType,
                    deliveryDate: format(selectedDate.date, 'yyyy-MM-dd'),
                    zipCode: deliveryZipCode,
                    locationType,
                    deliverySLA: selectedDate.data.deliverySLA,
                },
                attributes,
            };

            if (personalizationLines) {
                reqObj.personalization = {
                    personalizationType: 'PRODUCT_PERSONALIZATION',
                    personalizationLines,
                };
            }

            if (
                ageDetails && ageDetails.birthDay && ageDetails.birthMonth
                && ageDetails.birthYear && ageDetails.minAge && hasWine === 'true'
            ) {
                reqObj.wineVerify = {
                    ...ageDetails,
                };
            }

            if (isInternationalProduct) {
                reqObj.delivery.countryCode = internationalCountry;
            }
            actionAddToCart(
                reqObj,
                history,
                deliveryType, // FPT or GPT
                categoryId,
                productPartNumber,
                skipAddons,
                selectedDate.date,
                categoryName,
                categoryPath,
                isPassportBundleItem,
                movieSelected,
                selectedSku,
                passportBundle,
                retailPriceObj,
            );
        } else {
            const payload = {
                updateDeliveryDate: {
                    calendarDateType: selectedDate.data.calendarDateType,
                    deliveryDate: format(selectedDate.date, 'yyyy-MM-dd'),
                    deliverySLA: selectedDate.data.deliverySLA,
                },
                orderItemId,
            };
            const updateOrderProps = {
                page: location.pathname.includes('checkout') ? pageType : null,
                updateType: 'delivery',
            };
            actionUpdateOrder(payload, updateOrderProps, close);
            trackEvent({
                eventName: 'feature_interaction',
                eventCategory: 'Cart Page',
                eventAction: 'Delivery Date Updated',
                eventLabel: format(selectedDate.date, 'yyyy-MM-dd'),
            });
        }
    };

    mouseOverHandler = (surcharge, date) => {
        this.setState({ surcharge, focusedDate: date });
    };

    handleFlexClose = () => {
        this.setState({
            flex: {},
        });
    };

    determineDateColor = (typeOfDate, isFocused) => {
        // The default, unfocused view of a date is a white background with the date text as specific color (determined by CMS)
        // When the user focuses on a date the date text becomes white and the background color becomes what was the date text color
        const { cmsData } = this.props;
        const serviceLevels = cmsData.entries[0].service_levels || [];
        if (typeOfDate === 'unavailable') {
            // unavailable dates do not change their styling based on hovering so this function does not return any additional
            // inline styles for unavailable dates
            return null;
        }
        if (isFocused === true) {
            // if focused set the color to white and the background to the right color as determined by CMS.
            return { color: 'white', background: serviceLevels.filter((level) => level.type === typeOfDate)[0]?.color };
        }
        // else set the color to the CMS determined color and keep the background as its default white
        return { color: serviceLevels.filter((level) => level.type === typeOfDate)[0]?.color };
    }

    determineDateType = (dateObj) => {
        // more date types and checks will be added as needed.
        const dateInfo = dateObj.data;
        if (dateInfo === undefined) {
            // If there is no information object in the date object the date is not available
            return 'unavailable';
        }
        if (dateInfo?.flexDetails !== undefined) {
            return 'flex';
        }
        if (Number(dateInfo.surcharge) > 0 || Number(dateInfo.upcharge) > 0) {
            return 'surcharge';
        }
        return 'regular';
    }

    getFlexSurcharge = (flexDetails) => {
        if (!Array.isArray(flexDetails) || !flexDetails.length) {
            return 0;
        }
        // searches through the flex options and finds the highest surcharge if there are multiple
        const surcharge = Math.max(...flexDetails.map((o) => Number(o.flexAmount)), 0);
        return surcharge.toFixed(2);
    }

    roundNearest99 = (value) => {
        const valueFloat = parseFloat(value);
        // add 0.99 if the number doesn't have the decimal part i.e. 1, 2, 3, 4...
        if (valueFloat > 0 && valueFloat % 1 === 0) {
            return (valueFloat + 0.99).toFixed(2);
        }
        // if the number has decimal part then roud it up to the .99 i.e. 1.26 => 1.99
        if (valueFloat >= 0.01) {
            return (Math.ceil(valueFloat) - 0.01).toFixed(2);
        }
        return valueFloat.toFixed(2);
    };

    renderWeekDay = (day, dateObj, month) => {
        const { focusedDate, dateIcons, currencyRate } = this.state;
        const {
            classes, cmsData, dataDictionary, brand,
        } = this.props;
        const { available, date } = dateObj;
        const dateToFocus = date;
        const serviceLevels = cmsData?.entries[0]?.service_levels || [];
        const dateIsFocused = compareAsc(new Date(focusedDate), new Date(dateObj.date)) === 0;
        // The text color and background color of each date is determined by the type of date (surcharge, flex, holiday etc.)
        // and whether the user is currently hovering over that date.
        // The colors used come from CMS.
        // The typeOfDate function determines what type of date an individual date is.
        // the dateStyle functions returns an object that can be consumed by react as an inline style
        // see individual function implementations for descriptions of what they do.
        const typeOfDate = this.determineDateType(dateObj);
        const dateStyle = this.determineDateColor(typeOfDate, dateIsFocused);
        const formattedDate = format(new Date(dateObj.date), 'yyyy-MM-dd');
        const { data: { deliveryDate } = {} } = this.props.deliveryDate;
        let dateHasIcon = false;
        let dateIconData = null;
        if (dateIcons[formattedDate] && dateIcons[formattedDate]?.icon && dateObj?.data?.deliveryDate) {
            dateHasIcon = true;
            dateIconData = { iconData: dateIcons[formattedDate].icon };
        }
        if (date.getMonth() !== month) {
            return (
                <span
                    key={day}
                    className={classes.noDateAvailable}
                    style={{
                        color: serviceLevels.filter((level) => level.type === 'unavailable')[0]?.color || null,
                    }}
                >
                    {/* use &nbsp char to retain box spacing */}
                    &nbsp;
                </span>
            );
        }
        if (!available) {
            return (
                <span
                    key={day}
                    className={classes.noDateAvailable}
                    style={{
                        background: serviceLevels.filter((level) => level.type === 'unavailable')[0].color || null,
                    }}
                >
                    {' '}
                    <span key={day} className={classes.notVisible}>
                        {day}
                    </span>
                </span>
            );
        }

        const currency = getCurrencyName();
        const currencySymbol = getCurrencySymbol(currency);
        const standardCharge = dataDictionary?.['Standard Service Charge'] || 'Standard Service Charge';
        let totalSurcharge = (Number(dateObj.data.surcharge) + Number(dateObj.data.upcharge)).toFixed(2);
        if (dateObj?.data?.flexDetails && Number(totalSurcharge) === 0) {
            totalSurcharge = this.getFlexSurcharge(dateObj.data.flexDetails?.option);
        }
        const serviceChargeText = cmsData.entries[0].type.split(' ')[0] === 'FPT'
            ? dataDictionary?.['Service Charge'] || 'Service Charge'
            : dataDictionary?.['Shipping Charge'] || 'Shipping Charge';
        const hasSurcharge = dateObj.data && totalSurcharge > 0;
        const convertedTotalSurcharge = (currencyRate && Number(currencyRate) > 0) ? this.roundNearest99(totalSurcharge * Number(currencyRate)) : totalSurcharge;
        const serviceCharge = `${serviceChargeText} + ${currencySymbol}${convertedTotalSurcharge}`;

        const isFlexDate = !!dateObj?.data?.flexDetails;
        let flexSideRailMessage = null;
        if (isFlexDate) {
            const unparsedMessage = dateObj?.data?.flexDetails?.option?.[0]?.flexMsg?.find((message) => message.msgType === '6')?.msgText;
            if (unparsedMessage) flexSideRailMessage = ReactHTMLParser(dataDictionary?.[unparsedMessage] || unparsedMessage);
        }

        const surchargeMessage =   hasSurcharge
            ? () => {
                this.mouseOverHandler(serviceCharge, dateToFocus);
            }
            : () => (this.mouseOverHandler(standardCharge, dateToFocus));

        return (
            <span
                key={day}
                role="presentation"
                name="7"
                // the mouseOverHandler keeps track of both whether the user is hovering over any date
                // as well as whether the date they are hovering over has a surcharge.
                // if there is a surcharge we change what text we display on the calendar right banner
                // when the user is hovering over that date
                onMouseLeave={
                    hasSurcharge
                        ? () => {
                            this.mouseOverHandler(standardCharge);
                        }
                        : () => (this.mouseOverHandler(standardCharge))
                }
                onMouseEnter={
                    flexSideRailMessage
                        ? () => {
                            this.mouseOverHandler(flexSideRailMessage, dateToFocus);
                        }
                        :  surchargeMessage
                }
                onClick={() => {
                    this.selectDate(dateObj);
                }}
                className={
                    `${hasSurcharge
                        ? `${classes.dateAvailable} ${classes.dateSurcharge}`
                        : classes.dateAvailable} ${brand?.code === 'PLA' && deliveryDate !== 'undefined' && formattedDate === deliveryDate && classes.selecteDate}`
                }

                // This is where the styling determined by the above functions is applied
                style={dateStyle}
            >
                <span key={day} className={classes.notVisible}>
                    {/* if the date that the user is currently hovering over has a surcharge then display that surcharge in the cell */}
                    {/* otherwise continue to display the date */}
                    {dateIsFocused && convertedTotalSurcharge > 0  ?  `${currencySymbol}${convertedTotalSurcharge}` : day}
                    {dateHasIcon ? <img style={dateIsFocused ? { filter: 'brightness(0) saturate(100%) invert(99%) sepia(0%) saturate(1073%) hue-rotate(218deg) brightness(117%) contrast(100%)' } : null} className={classes.dateIcon} src={dateIconData?.iconData?.url} alt={dateIconData?.iconData?.name} height="13" width="13" /> : null}
                </span>
                <DesktopMobile
                    mobile={() => <p className={classes.surcharge}>{convertedTotalSurcharge > 0 ? `+ ${currencySymbol}${convertedTotalSurcharge}` : ' '}</p>}
                    desktop={() => <p className={classes.surcharge}>{convertedTotalSurcharge > 0 ? `+ ${currencySymbol}${convertedTotalSurcharge}` : ' '}</p>}
                />
            </span>
        );
    };

    renderMonthTitles = (monthName, year, checkCurrentMonth = false, deliveryDatesInNextMonth) => {
        const { classes, dataDictionary } = this.props;
        const { prevBtnCheck } = this.state;
        const prevBtn = checkCurrentMonth && prevBtnCheck ? (
            <span
                role="presentation"
                onClick={() => {
                    this.preMonth();
                }}
                className={classes.prevBtn}
            >
                {dataDictionary?.['PREV'] || 'PREV'}
            </span>
        ) : null;
        const nextBtn = (checkCurrentMonth && deliveryDatesInNextMonth) && (
            <span
                role="presentation"
                onClick={() => {
                    this.nextMonth();
                }}
                className={classes.nextBtn}
            >
                {dataDictionary?.['NEXT'] || 'NEXT'}
            </span>
        );

        return (
            <div className={classes.weekDayName}>
                <div className={classes.monthTitle}>
                    {prevBtn}
                    {dataDictionary?.[monthName] || monthName} {year}
                    {nextBtn}
                </div>
                {WWW_WEEKDAY_SHORTNAMES.map((name) => (
                    <span key={name} className={classes.weekDay}>
                        {dataDictionary?.[name] || name}
                    </span>
                ))}
            </div>
        );
    };

    closeAndResetState = () => {
        const { close } = this.props;
        close();
        this.setState({
            prevBtnCheck: false,
            surcharge: 'Standard Service Charge',
            now: '',
            end: '',
            spinnerActive: false,
        });
    };

    renderQueryByCurrency = (currency) => {
        const { brand, partNumber, selectedSku } = this.props;
        const { retailPriceObj } = this.state;
        const FIND_PRODUCT_PAGE_BY_PARTNUMBER = findProductPageByPartNumber(brand.domain, partNumber, currency);
        if (retailPriceObj[currency] === undefined) {
            return (
                <Query query={FIND_PRODUCT_PAGE_BY_PARTNUMBER}>
                    {
                        ({ loading, error, data }) => {
                            if (loading) return null;
                            if (error) {
                                mbpLogger.logError({
                                    jsError: error,
                                    message: `Failed to fetch data for: ${FIND_PRODUCT_PAGE_BY_PARTNUMBER} on brand ${brand} on component GraphqlPDPCalendar`,
                                });
                            }

                            const product = data?.findProductPageByPartNumber?.product || null;
                            if (product) {
                                if (Array.isArray(product.productSkus) && product.productSkus.length) {
                                    const copySelectedSku = product.productSkus.find((sku) => sku.id === selectedSku?.id);
                                    if (copySelectedSku) {
                                        const newRetailPriceObj = { ...retailPriceObj, [currency]: copySelectedSku.prices?.[0]?.value };
                                        this.setState({
                                            retailPriceObj: newRetailPriceObj,
                                        });
                                    }
                                }
                            }
                            return true;
                        }
                    }
                </Query>
            );
        }
        return null;
    };

    availableCurrencies = () => {
        const { brand } = this.props;
        const currentCurrency = getCurrencyName();
        const currenciesArray = ['USD'];
        if (brand.code === 'CAN' || brand.code === '08F') {
            currenciesArray.push('CAD');
        }
        if (brand.code === '08F') {
            currenciesArray.push('EUR', 'GBP');
        }
        // return currenciesArray.filter((item) => item !== currentCurrency);
        return currenciesArray.filter((item) => item === currentCurrency);
    };

    render() {
        const {
            surcharge, now, end, spinnerActive, flex,
        } = this.state;
        const {
            isOpen, /* close, */ classes, cmsData, todayTomDateNotAvailText, cartError, loader, isCheckout, flags, dataDictionary, brand,
        } = this.props;
        if (!cmsData?.entries?.[0]) {
            return null;
        }

        const serviceLevels = cmsData.entries[0].service_levels || [];
        const deliveryImage = cmsData.entries[0].local_florist_delivery_icon !== null
            ? cmsData.entries[0].local_florist_delivery_icon?.url
            : cmsData.entries[0].shipping_in_gift_box_icon?.url;

        if (!now) {
            return null;
        }
        const calendar = this.generateCalendar(now, end);
        const nextMonth = firstOfNextMonth(now);
        const currentMonthArray = this.generateMonth(
            calendar,
            getWeek(startOfMonth(new Date(now)), { weekStartsOn }),
            getWeek(endOfMonth(new Date(now)), { weekStartsOn }),
        );
        let nextMonthArray = [];
        if (!isSameMonth(now, end)) {
            nextMonthArray = this.generateMonth(
                calendar,
                getWeek(new Date(nextMonth), { weekStartsOn }),
                getWeek(endOfMonth(new Date(nextMonth)), { weekStartsOn }),
            );
        }

        const availableCurrencies = this.availableCurrencies();

        return (
            <div>
                {/* logic to support multicurrency in the retailPrice (stored in redux (ui -> currentProduct -> retailPrice) for checkout flow) */}
                {availableCurrencies.map((item) => this.renderQueryByCurrency(item))}
                {/* next line is part of mother's day flow
                if there are products available in that specific category then we activate an alternate
                calendar view.
                The query component below checks for products in that category
                if some are returned it changes a variable in calendar state which actives the alternative view
                 */}
                {(loader && !isCheckout) && <GraphqlPortalLoader />}
                {flex.flexActivated === true ? <FlexModal flexData={flex.flexData} isOpen={flex.flexActivated} handleFlexClose={this.handleFlexClose} flexAddToCart={this.flexAddToCart} /> : null}
                <Dialog
                    className={`${classes.modelContainer} ${(cartError ? classes.maxClosedWidth : null)}`}
                    open={isOpen}
                    classes={
                        spinnerActive
                            ? {
                                paper: classes.loadingFadeOut,
                            }
                            : null
                    }
                >
                    {!cartError && (
                        <>
                            <div className={classes.modelHeader}>
                                {dataDictionary?.['SELECT DELIVERY DATE'] || 'SELECT DELIVERY DATE'}
                                <span
                                    onClick={this.closeAndResetState}
                                    role="presentation"
                                    className={classes.closeModal}
                                    id="close-full-calendar"
                                    data-test="pdp-close-full-calendar"
                                    name="closeFullCalendar"
                                >
                                    X
                                </span>
                            </div>
                            {todayTomDateNotAvailText
                                ? (
                                    <div className={classes.todayTomDateNotAvailContainer}>
                                        <p>
                                            {todayTomDateNotAvailText}
                                        </p>
                                    </div>
                                ) : null}
                            <DialogTitle className={classes.testClassDialogTitle}>
                                <div className={classes.leftCalendar}>
                                    {this.renderMonthTitles(
                                        MMMM_MONTH_NAMES[now.getMonth()],
                                        getYear(now),
                                        true,
                                        nextMonthArray.length > 0,
                                    )}
                                    {currentMonthArray.map((week) => (
                                        <div
                                            key={formatDateYYYY_MM_DD(week[0].date)}
                                            className={classes.daysRow}
                                        >
                                            {week.map((day) => this.renderWeekDay(
                                                z2fmt(day.date.getDate()),
                                                day,
                                                now.getMonth(),
                                            ))}
                                        </div>
                                    ))}
                                    {spinnerActive ? (
                                        <div className={classes.spinnerContainer}>
                                            <CircularProgress
                                                className={classes.spinner}
                                            />
                                        </div>
                                    ) : null}
                                    {nextMonthArray.length > 0 && this.renderMonthTitles(
                                        MMMM_MONTH_NAMES[nextMonth.getMonth()],
                                        getYear(end),
                                        false,
                                    )}
                                    {nextMonthArray.map((week) => (
                                        <div
                                            key={formatDateYYYY_MM_DD(week[0].date)}
                                            className={classes.daysRow}
                                        >
                                            {week.map((day) => this.renderWeekDay(
                                                z2fmt(day.date.getDate()),
                                                day,
                                                now.getMonth() === 11
                                                    ? 0
                                                    : now.getMonth() + 1,
                                            ))}
                                        </div>
                                    ))}
                                    <div className={classes.mobBottomDiv}>
                                        <div className={classes.mobBottomLeft}>
                                            {serviceLevels.map((serviceLevel) => (
                                                <div key={serviceLevel.name}>
                                                    <div className={classes.mainDiv}>
                                                        <span
                                                            className={
                                                                classes.deliveryIcon
                                                            }
                                                            style={{
                                                                background:
                                                                    serviceLevel.color,
                                                            }}
                                                        />{' '}
                                                        {dataDictionary?.[serviceLevel.name] || serviceLevel.name}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        {!(brand?.code === 'PLA') && (
                                            <div className={classes.mobBottomRight}>
                                                {' '}
                                                <img alt="Delivery" src={deliveryImage} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className={classes.rightCalendar}>
                                    <div className={classes.rightTop}>
                                        <span>{dataDictionary?.['Service Details'] || 'Service Details'}</span>
                                        <p>
                                            {dataDictionary?.['Rollover a date in the Calendar to view'] || 'Rollover a date in the Calendar to view'}
                                            {dataDictionary?.['Service Details'] || 'Service Details'}{' '}
                                        </p>
                                    </div>
                                    {flags && flags['is-delivery-type-shown'] && (
                                        <div className={classes.deliveryImg}>
                                            <img alt="Delivery" src={deliveryImage} />
                                        </div>
                                    )}
                                    <div className={classes.standardCharge}>
                                        {dataDictionary?.[surcharge] || surcharge}
                                    </div>
                                    <div className={brand?.code === 'PLA' ? classes.plaMobMark : classes.mobMark}>
                                        {serviceLevels.map((serviceLevel) => (
                                            <div key={serviceLevel.name}>
                                                <div className={classes.mobMarkDiv}>
                                                    <span
                                                        className={classes.deliveryIcon}
                                                        style={{
                                                            background:
                                                                serviceLevel.color,
                                                        }}
                                                    />{' '}
                                                    {dataDictionary?.[serviceLevel.name] || serviceLevel.name}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {!(brand?.code === 'PLA') && (
                                        <div className={classes.rightLogo}>
                                            <img
                                                className={classes.rightLogoImage}
                                                alt="Right Logo"
                                                src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltbef130337359e49f/5e222a4f1f2985503218165f/The_Right_Gift_Calendar_Icon.jpeg"
                                            />
                                        </div>
                                    )}
                                </div>
                            </DialogTitle>
                        </>
                    )}
                    {
                        cartError && (
                            <>
                                <div className={`${classes.modelHeader} ${classes.closeModalEmpty}`}>
                                    <span
                                        onClick={this.closeAndResetState}
                                        role="presentation"
                                        className={classes.closeModal}
                                        id="close-full-calendar"
                                        data-test="pdp-close-full-calendar"
                                        name="closeFullCalendar"
                                    >
                                        X
                                    </span>
                                </div>
                                <DialogTitle>
                                    <p className={classes.cartError}><ErrorOutlineIcon className={classes.errorIcon} />{ReactHTMLParser(cartError)}</p>
                                </DialogTitle>
                            </>
                        )
                    }
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locationType: getLocationType(state),
    jwt: getAccessToken(state),
    cartError: getCartError(state),
    validatedZip: getValidatedZipcode(state),
    userSubmittedZip: getUserSubmittedProductFilterZipcode(state),
    loader: getLoaderStatus(state),
    isCheckout: isCheckoutPage(),
    flags: getFeatureFlags(state),
    dataDictionary: getDataDictionary(state),
    brand: getBrand(state),
});

const mapDispatchToProps = (dispatch) => ({
    actionAddToCart: bindActionCreators(checkoutActions.addToCart, dispatch),
    actionUpdateOrder: bindActionCreators(updateOrder, dispatch),
    clearCartError: bindActionCreators(errorActions.clearErrors, dispatch),
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
});

CalendarModal.propTypes = {
    classes: object.isRequired,
    isOpen: bool.isRequired,
    close: func.isRequired,
    locationType: string.isRequired,
    actionAddToCart: func.isRequired,
    jwt: string.isRequired,
    brandId: string.isRequired,
    selectedItemId: string,
    // validatedZip: string.isRequired,
    history: object.isRequired,
    cmsData: object.isRequired,
    userSubmittedZip: string.isRequired,
    setCalendarDataLoadingFlag: func.isRequired,
    handleDeliveryAvailability: func.isRequired,
    location: object.isRequired,
    actionUpdateOrder: func.isRequired,
    orderItemId: string,
    deliveryType: string,
    ageDetails: shape({
        birthDay: string,
        birthMonth: string,
        birthYear: string,
        minAge: string,
    }).isRequired,
    partNumber: string.isRequired,
    todayTomDateNotAvailText: string,
    sympathyValue: string.isRequired,
    pageType: string,
    clearCartError: func,
    cartError: string,
    zipCode: string,
    loader: bool.isRequired,
    isCheckout: bool.isRequired,
    trackEvent: func.isRequired,
    isInternationalProduct: bool,
    internationalCountry: string,
    flags: object.isRequired,
    isPassportBundleItem: bool,
    personalization: shape({
        indicator: string,
        lineState: arrayOf(
            shape({
                lineNumber: number.isRequired,
                maxChars: number.isRequired,
            }).isRequired,
        ),
        modalOpen: bool.isRequired,
    }).isRequired,
    movieSelected: shape({
        error: bool,
        skuSelected: shape({
            sku: string.isRequired,
            sku_description: string.isRequired,
            sku_price: number.isRequired,
        }),
    }),
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        passportSku: string,
        enable: bool,
    }),
    selectedSku: shape({
        prices: {
            type: string,
            value: number,
        },
    }).isRequired,
    hasWine: string,
    dataDictionary: object,
    brand: shape({
        domain: string,
        code: string,
    }).isRequired,
    passportInCart: bool,
    isPassportUser: bool,
    isUserLoggedIn: bool,
    setDeliveryDate: func,
    deliveryDate: object,
};

CalendarModal.defaultProps = {
    selectedItemId: null,
    orderItemId: '',
    clearCartError: () => {},
    deliveryType: '',
    todayTomDateNotAvailText: '',
    pageType: '',
    cartError: '',
    zipCode: null,
    isInternationalProduct: false,
    internationalCountry: '',
    isPassportBundleItem: false,
    movieSelected: null,
    isPassportBundleProduct: {},
    hasWine: 'false',
    dataDictionary: {},
    passportInCart: false,
    isPassportUser: false,
    isUserLoggedIn: false,
    setDeliveryDate: () => {},
    deliveryDate: {},
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withStyles(styles)(CalendarModal)),
);
